module.exports = __webpack_public_path__ + "static/intercon_management_consulting_story-e063e29e7684f6c86c7f1d6ee125db77.png";